import { useIdentificationDocumentReminderCreateMutation } from "web_myplann/Api/Reminders/useIdentificationDocumentReminderCreateMutation";
import { usePortfolioReminderCreateMutation } from "web_myplann/Api/Reminders/usePortfolioReminderCreateMutation";
import { usePropertyReminderCreateMutation } from "web_myplann/Api/Reminders/usePropertyReminderCreateMutation";
import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { getReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import { useReminderForm } from "web_myplann/Reminders/Hooks/useReminderForm";
import type {
	ReminderEntity,
	ReminderTemplate,
} from "web_myplann/Reminders/Types/ReminderTypes";

type UseReminderCreateFormProps = {
	entity: ReminderEntity;
	templates: ReminderTemplate[];
	validTo?: Date | null;
	onSuccess: () => void;
};

export const useReminderCreateForm = ({
	entity,
	templates,
	validTo = entity.validTo,
	onSuccess,
}: UseReminderCreateFormProps) => {
	const { mutate: createPortfolioReminder, isPending: isCreatingPortfolio } =
		usePortfolioReminderCreateMutation();
	const { mutate: createPropertyReminder, isPending: isCreatingProperty } =
		usePropertyReminderCreateMutation();
	const { mutate: createDocumentReminder, isPending: isCreatingDocument } =
		useIdentificationDocumentReminderCreateMutation();

	const entityConfig = getReminderEntityConfig(entity.type);

	const { form } = useReminderForm({ entityConfig, templates, validTo });

	const submit = form.handleSubmit((model) => {
		switch (entity.type) {
			case ReminderEntityTypeEnum.Portfolio:
				createPortfolioReminder(
					{ portfolioId: entity.id, model },
					{ onSuccess },
				);
				return;
			case ReminderEntityTypeEnum.IdentificationDocument:
				createDocumentReminder({ documentId: entity.id, model }, { onSuccess });
				return;
			default:
				createPropertyReminder({ propertyId: entity.id, model }, { onSuccess });
		}
	});

	return {
		form,
		submit,
		entityConfig,
		isSubmitting:
			isCreatingPortfolio || isCreatingProperty || isCreatingDocument,
	};
};
